module.exports = __webpack_public_path__ + "static/media/chicken_fajitas.6f081687.jpg";